import React, { FC } from 'react';
import { Text } from '@carnica/ui-kit';
import { useIsMobileDimension } from '@carnica/utils/hooks';
import classNames from 'classnames/bind';

import styles from './styles.pcss';

const cn = classNames.bind(styles);

export type AddressProps = {
  address: string;
  className?: string;
  isMobile?: boolean;
};

export const Address: FC<AddressProps> = ({ address, className, isMobile }) => {
  const isMobileDimension = useIsMobileDimension();

  return (
    <Text
      className={cn('address', className)}
      variant={isMobile || isMobileDimension ? 'body-small' : 'body-medium'}
    >
      {address}
    </Text>
  );
};
